import { Node } from '@tiptap/core'
import { textblockTypeInputRule } from 'prosemirror-inputrules'
// import { VueNodeViewRenderer } from '@tiptap/vue-3'
import VueNodeViewRenderer from '@/tiptap/utils/VueNodeViewRenderer'

import languages from '@/core/code-languages'
import low from 'lowlight/lib/core'

import CodeBlockHighlight from '../plugins/CodeBlockHighlight'
import CodeBlockComponent from './CodeBlockComponent.vue'

languages.forEach(language => {
  if (language.value && language.config) {
    low.registerLanguage(language.value, language.config)
  }
})

export const backtickInputRegex = /^```(?<language>[a-z]*)? $/
export const tildeInputRegex = /^~~~(?<language>[a-z]*)? $/

export const CodeBlock = Node.create({
  name: 'codeBlock',

  defaultOptions: {
    HTMLAttributes: {
    }
  },

  content: 'text*',
  marks: '',
  group: 'block',
  atom: true,
  code: true,
  defining: true,
  selectable: false,

  addAttributes () {
    return {
      language: {
        default: null,
        parseHTML: element => {
          const language = element.firstElementChild?.getAttribute('data-lang')

          if (!language) {
            return null
          }

          return {
            language: language
          }
        },
        renderHTML: attributes => {
          if (!attributes.language) {
            return null
          }

          return {
            'data-lang': attributes.language
          }
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'pre',
        preserveWhitespace: 'full'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['pre', this.options.HTMLAttributes, ['code', HTMLAttributes, 0]]
  },

  addCommands () {
    return {
      setCodeBlock: attributes => ({ commands }) => {
        return commands.setNode('codeBlock', attributes)
      },

      toggleCodeBlock: attributes => ({ commands }) => {
        return commands.toggleNode('codeBlock', 'paragraph', attributes)
      }
    }
  },

  addInputRules () {
    return [
      textblockTypeInputRule(backtickInputRegex, this.type, ({ groups }) => groups),
      textblockTypeInputRule(tildeInputRegex, this.type, ({ groups }) => groups)
    ]
  },

  addProseMirrorPlugins () {
    return [
      CodeBlockHighlight({ name: 'codeBlock' })
    ]
  },

  addNodeView () {
    return VueNodeViewRenderer(CodeBlockComponent, {
      as: 'div',
      contentAs: 'code',
      hasContent: true
    })
  }
})
